export const managePageMessages = {
  editLink: 'Edit Link',
  linkLoadFailed: 'Failed to load link',
  linkNotFound: 'Link not found.',
  slugRequired: 'Slug is required',
  slugLabel: 'Slug *',
  linkUpdated: 'Link updated!',
  saveChanges: 'Save Changes',
  suggest: 'Suggest',
  suggestionsReady: 'Suggestions ready',
  shortDomain: 'Short Domain',
  apiHost: 'API host',
  defaultOption: 'default',
  descriptionOptional: 'Description (optional)',
  descriptionPlaceholder: 'Short internal note or page summary',
  expiresAt: 'Expires At (optional)',
  maxClicks: 'Max Clicks (optional)',
  showWarning: 'Show safety warning before redirect',
  fallbackUrlOptional: 'Fallback URL (optional)',
  fallbackUrlHint:
    'Stored for health monitoring and future fallback workflows. It does not change redirect behavior.',
  passwordOptional: 'Password (optional)',
  newPasswordOptional: 'New Password (optional)',
  keepPasswordHint:
    'Leave untouched to keep the current password. Edit back to empty to clear it.',
  passwordHint: 'Visitors must enter this password before opening the destination.',
  clearPassword: 'Clear existing password',
  tagsCount: '{count} tags',
  createTag: 'Create Tag',
  editTag: 'Edit Tag',
  searchTags: 'Search tags',
  noTagsFound: 'No tags found',
  tag: 'Tag',
  description: 'Description',
  updated: 'Updated',
  name: 'Name',
  color: 'Color',
  save: 'Save',
  tagColor: 'Tag color',
  tagsLoadFailed: 'Failed to load tags',
  tagNameRequired: 'Tag name is required',
  tagUpdated: 'Tag updated',
  tagCreated: 'Tag created',
  tagDeleted: 'Tag deleted',
  deleteTag: 'Delete Tag',
  deleteTagConfirm: 'Delete "{name}"? It will also be removed from links that use it.',
  importExportSubtitle: 'Import links from Shlink or CSV/JSON files, export your data',
  importLinks: 'Import Links',
  exportData: 'Export Data',
  sourceFormat: 'Source Format (optional)',
  autoDetect: 'Auto-detect',
  bitlyCsvFormat: 'Bitly CSV',
  shortIoCsvFormat: 'Short.io CSV',
  linketryBackupFormat: 'Linketry backup.json',
  genericCsvFormat: 'Generic CSV',
  genericJsonFormat: 'Generic JSON / JSONL',
  shlinkUrl: 'Shlink URL',
  shlinkApiKey: 'Shlink API Key',
  fetchShlink: 'Fetch Shlink',
  enterShlink: 'Enter Shlink URL and API key',
  fetchedShlink: 'Fetched {count} Shlink links',
  conflictHandling: 'Conflict Handling',
  skipSlugs: 'Skip existing slugs',
  renameSlugs: 'Rename conflicting slugs',
  overwriteSlugs: 'Overwrite existing slugs',
  conflictHint:
    'Skip is safest. Overwrite updates existing links and requires a pre-import backup.',
  uploadFile: 'Upload File',
  uploadHint: 'Click to upload .json, .csv, .jsonl (up to {max})',
  selectImportContent: 'Please select a file or paste content',
  importFileTooLarge: 'This import file is larger than the {max} limit.',
  importFileReadFailed: 'This import file could not be read.',
  preview: 'Preview',
  importLinksCount: 'Import {count} Links',
  noLinksToImport: 'No Links to Import',
  exportLinksCsv: 'Links CSV',
  exportLinksJson: 'Links JSON',
  exportVisitsCsv: 'Visits CSV',
  fullBackup: 'Full Backup',
  download: 'Download',
  importHistory: 'Import History',
  noImports: 'No imports yet.',
  fieldMapping: 'Field Mapping (optional)',
  fieldMappingHint:
    'JSON object mapping Linketry fields to source columns. Supported fields: slug, longUrl, title, tags, clicks, createdAt, expiresAt, maxClicks.',
  invalidFieldMapping: 'Field mapping must be valid JSON',
  noImportable: 'No importable links found. Existing slugs are skipped by default.',
  importComplete:
    'Backup downloaded. Import complete: {success} imported, {skipped} skipped, {failed} failed',
  importFailed:
    'Backup downloaded, but the import failed. Check the import history report for details.',
  importProcessing: 'Importing…',
  charsLoaded: '{count} chars loaded from {source}',
  pastedInput: 'pasted input',
  previewFound: 'Preview: {count} items found',
  valid: 'Valid',
  conflicts: 'Conflicts',
  invalid: 'Invalid',
  noImportResult:
    'No links will be imported. Existing slugs are skipped by the selected conflict strategy.',
  conflictPreview: '{count} conflicting slugs will be {action}.',
  renamedAction: 'renamed',
  overwrittenAction: 'overwritten',
  conflictLabel: 'conflict',
  moreItems: '… and {count} more',
  date: 'Date',
  source: 'Source',
  file: 'File',
  totalLabel: 'Total',
  successLabel: 'Success',
  skipped: 'Skipped',
  failed: 'Failed',
  report: 'Report',
  suggestions: 'Suggestions',
  applyAll: 'Apply All',
  slugs: 'Slugs',
  addAll: 'Add all',
  utmTemplate: 'UTM Template',
  savedUtmTemplates: 'Saved UTM templates',
  utmTemplateName: 'Template name',
  saveTemplate: 'Save template',
  deleteTemplate: 'Delete template',
  utmTemplateSaved: 'UTM template saved',
  utmTemplateDeleted: 'UTM template deleted',
  utmTemplatesLoadFailed: 'Failed to load UTM templates',
  internalNote: 'Internal Note',
  internalNoteHint: 'Private operator context; never shown on public pages or analytics.',
  internalNotePlaceholder: 'Add a private note for this link...',
  saveNote: 'Save note',
  noteSaved: 'Internal note saved',
  previewOpenGraph: 'Preview OpenGraph',
  openGraphPreview: 'OpenGraph Preview',
  noPreviewTitle: 'Untitled page',
  replaceUrls: 'Replace URLs',
  findText: 'Find text',
  replaceWith: 'Replace with',
  replaceUrlGuidance:
    'Preview first. Confirmation skips links changed since preview and downloads a rollback CSV.',
  previewChanges: 'Preview changes',
  confirmReplace: 'Confirm replacement',
  readyStatus: 'ready',
  invalidStatus: 'invalid',
  unchangedStatus: 'unchanged',
  bulkUrlsUpdated: 'Updated {count} destination URLs',
  migrateShortDomain: 'Migrate short-link domain',
  sourceShortDomain: 'Current short-link domain',
  targetShortDomain: 'New short-link domain',
  domainMigrationGuidance:
    'This changes the short-link domain only. Slugs and destination/Aff URLs stay unchanged. Make sure the new domain DNS and Worker route are active before confirming. A migration record CSV will download after completion.',
  domainMigrationCount: '{count} matching links will be migrated',
  targetDomainNotRegistered:
    'The new domain is not active in Linketry’s domain catalog. You can continue only if its DNS and Worker route are already configured.',
  previewMigration: 'Preview migration',
  confirmDomainMigration: 'Confirm domain migration',
  domainMigrationComplete: 'Migrated the short-link domain for {count} links',
  utmHint: 'Build campaign parameters into the destination URL.',
  apply: 'Apply',
  template: 'Template',
  custom: 'Custom',
  newsletter: 'Newsletter',
  social: 'Social',
  paidAds: 'Paid Ads',
  affiliate: 'Affiliate',
  validDestinationFirst: 'Enter a valid destination URL first',
  advancedFilters: 'Advanced Filters',
  advancedFiltersActive: '{count} active',
  clear: 'Clear',
  anyPassword: 'Any Password',
  noPassword: 'No Password',
  anyWarning: 'Any Warning',
  warningEnabled: 'Warning Enabled',
  warningDisabled: 'Warning Disabled',
  anyLimits: 'Any Limits',
  hasLimits: 'Has Limits',
  noLimits: 'No Limits',
  selectedCount: '{count} selected',
  limitsLabel: 'Limits',
  none: 'None',
  until: 'Until {date}',
  bulkUpdated: 'Bulk {action}: {count} updated',
  enterTag: 'Enter at least one tag',
  tagsUpdated: 'Tags updated on {count} links',
  bulkEditTags: 'Bulk Edit Tags',
  mode: 'Mode',
  applyTags: 'Apply Tags',
  deleteLinks: 'Delete Links',
  disableLinks: 'Disable Links',
  archiveLinks: 'Archive Links',
  deleteLinksConfirm: 'Delete {count} selected links? This cannot be undone.',
  disableLinksConfirm: 'Disable {count} selected links? They will stop redirecting.',
  archiveLinksConfirm: 'Archive {count} selected links?',
  addTagsMode: 'Add to existing tags',
  replaceTagsMode: 'Replace existing tags',
  removeTagsMode: 'Remove matching tags',
  clearTagsMode: 'Clear all tags',
  clearTagsHint: '{count} selected links will have all tags removed',
  commaTags: 'Comma-separated tags',
} as const;
